import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firebaseAction, firestoreAction } from 'vuexfire'
const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        // Firestore
        site: {
            name: 'OneMgl'
        },
        location: {
            country: 'CA',
            countryId: '38',
            state: 'British Columbia',
            stateId: '664',
            city: 'Vancouver',
            cityId: '48400'
        },
        currentUser: null,
        userProfile: {},
        userProfileFriends: null,
        allUsers: {},
        allUsersNew: null,
        allUserPoints: {},
        isMember: false,
        darkMode: true,
        locations: {
            'Vancouver': {
                country: 'CA',
                countryId: '38',
                state: 'British Columbia',
                stateId: '664',
                city: 'Vancouver',
                cityId: '48400',
                imageUrl: 'https://images.prismic.io/vanmglcom/2ffdadc7-cb84-4457-a7b6-d71a266f7b4e_photo-1519331582073-283f1a211a3e.jpg?auto=compress,format'
            },
            'Calgary': {
                country: 'CA',
                countryId: '38',
                state: 'Alberta',
                stateId: '663',
                city: 'Calgary',
                cityId: '10107',
                imageUrl: 'https://images.prismic.io/vanmglcom/68ab0dfa-edd6-4bfc-9828-95da2983fb00_photo-1526863336296-fac32d550655.jpg?auto=compress,format'
            }
        },
        // Realtime DB
        chats: null,
        settings: null,
        usersOnline: null
    },
    actions: {
        clearData({ commit }) {
            commit('setCurrentUser', null)
            commit('setUserProfile', {})
        },
        fetchDefaultLocation({ commit, state }){
            
            let defaultLocation = window.localStorage.getItem('defaultLocation')

            // console.log('Default location from Store: ', defaultLocation, state.locations[defaultLocation])

            if(defaultLocation !== null && typeof(defaultLocation) !== 'undefined'){
                commit('setNewLocation', state.locations[defaultLocation])
            }
        },
        async fetchAllUsers({ commit }){

            let allUsersObj = {}
            
            await fb.usersCollection.orderBy('timestamp', 'desc').get().then(snap => {

                snap.forEach(member => {
                    allUsersObj[member.id] = member.data()
                })

                commit('setAllUsers', allUsersObj)

            }).catch(err => {
                console.log('Error getting all users: ', err.message)
            })
        },
        async fetchUserProfile({ commit }, user) {
            await fb.usersCollection.doc(user.uid).get().then(res => {

                // Existing Users
                if(res.exists){

                    let userData = res.data()
                    let updateData = {}

                    // Metadata
                    if(typeof(userData.metadata) === 'undefined'){
                        
                        let metadata = {
                            a: user.metadata.a,
                            b: user.metadata.b,
                            creationTime: user.metadata.creationTime,
                            lastSignInTime: user.metadata.lastSignInTime
                        }

                        updateData.metadata = metadata
                        userData.metadata = metadata
                    }

                    // Set Provider
                    if(typeof(userData.providerData) === 'undefined'){
                        updateData.providerData = user.providerData
                        userData.providerData = user.providerData
                    }

                    // Update Fields if necessary
                    if(Object.keys(updateData).length > 0){

                        fb.usersCollection.doc(user.uid).update(updateData).then(() => {
                            console.log('Successfully updated user profile data: ', updateData)
                        }).catch((err) => {
                            console.log('Error updating user profile data!', err.message)
                        })
                    }

                    console.log('Current existing user profile: ', userData)

                    commit('setUserProfile', userData)

                // New Users
                }else{
                    
                    let fullName = user.displayName
                    let firstName = typeof(user.displayName) !== 'undefined' ? fullName.split(' ').slice(0, -1).join(' ') : null
                    let lastName = typeof(user.displayName) !== 'undefined' ? fullName.split(' ').slice(-1).join(' ') : null
                    let sendEmail = typeof(user.email) !== 'undefined' !== null ? true : false
                    let sendTxt = typeof(user.phoneNumber) !== 'undefined' ? true : false
                    let phoneNumber = typeof(user.phoneNumber) !== 'undefined' ? user.phoneNumber : null
                    let location = typeof(user.location) !== 'undefined' ? user.location : null


                    let defaultProfile = {
                        displayName: fullName,
                        firstName: firstName,
                        lastName: lastName,
                        email: user.email,
                        emailVerified: user.emailVerified,
                        phoneNumber: phoneNumber,
                        photoURL: user.photoURL,
                        uid: user.uid,
                        isMember: false,
                        darkMode: true,
                        timestamp: fb.firebase.firestore.FieldValue.serverTimestamp(),
                        settings: {
                            sendEmail: sendEmail,
                            sendTxt: sendTxt
                        },
                        points: 0,
                        metadata: null,
                        providerData: null,
                        location: location
                    }

                    // Set Metadata
                    if(typeof(user.metadata) !== 'undefined'){
                        
                        let metadata = {
                            a: user.metadata.a,
                            b: user.metadata.b,
                            creationTime: user.metadata.creationTime,
                            lastSignInTime: user.metadata.lastSignInTime
                        }

                        defaultProfile.metadata = {}
                        defaultProfile.metadata = metadata
                    }

                    // Set ProviderData
                    if(typeof(user.providerData) !== 'undefined'){
                        defaultProfile.providerData = user.providerData
                    }

                    console.log('Current new user profile: ', defaultProfile)

                    fb.usersCollection.doc(user.uid).set(defaultProfile).then(() => {
                        commit('setUserProfile', defaultProfile)
                    }).catch((err) => {
                        console.log('Error setting user profile in store!')
                    })
                }
            }).catch(err => {
                console.log('Error setting user profile: ', err)
            })
        },
        async toggleDarkMode({ commit, state}) {

            let newDarkModeState = !state.darkMode

            commit('setDarkMode', newDarkModeState)

            // Save Dark Mode in User Settings
            if(state.userProfile !== null && state.currentUser !== null){
                await fb.usersCollection.doc(state.currentUser.uid).update({
                    darkMode: newDarkModeState
                }).catch((err) => {
                    console.log('Error setting user dark mode in settings!')
                })
            }
        },
        updateLocation({ commit }, item) {
            commit('setNewLocation', item)
        },
        // Realtime DB
        bindSettings: firebaseAction(({ bindFirebaseRef }) => {
            return bindFirebaseRef('settings', fb.rdb.ref('settings'))
        }),
        bindOnlineStatus: firebaseAction(({ bindFirebaseRef }) => {
            return bindFirebaseRef('usersOnline', fb.rdb.ref('status'))
        }),
        bindChats: firebaseAction(({ bindFirebaseRef }) => {
            return bindFirebaseRef('chats', fb.rdb.ref('chats'))
        }),
        // Firestore DB
        bindAllUsers: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef('allUsersNew', fb.db.collection('users').orderBy('timestamp', 'desc'))
        }),
        bindUserProfileFriends: firestoreAction(({ bindFirestoreRef }, user) => {
            return bindFirestoreRef('userProfileFriends', fb.db.collection('users').doc(user.uid).collection('friends'))
        })
    },
    mutations: {
        setAllUsers(state, val){
            state.allUsers = val
        },
        setCurrentUser(state, val){
            state.currentUser = val
        },
        setUserProfile(state, val){

            state.userProfile = val

            if(Object.keys(val).length > 0){
                
                // Set Membership Status
                let isMember = false
                if(state.userProfile.isMember !== null){
                    if(state.userProfile.isMember === true){
                        isMember = true
                    }
                }
                state.isMember = isMember

                // Set Dark Mode
                if(state.userProfile.darkMode !== null){

                    state.darkMode = state.userProfile.darkMode

                    if(state.darkMode){
                        document.body.classList.add('dark')
                    }else{
                        document.body.classList.remove('dark')
                    }

                    // console.log('Set Dark Mode: ', state.darkMode)
                }
            }
        },
        setDarkMode(state, val){

            state.darkMode = val

            if(state.darkMode){
                document.body.classList.add('dark')
            }else{
                document.body.classList.remove('dark')
            }
        },
        setAllUserPoints(state, val){
            state.allUserPoints = val
        },
        setNewLocation(state, val){
            state.location = val
        },
        ...vuexfireMutations
    },
    getters: {
        getUserProfile(state) {
            return state.userProfile
        },
        getAllUsers: state => {
            return state.allUsersNew
        },
        getAllOnlineUsers: state => {

            let usersOnline = {}

            Object.keys(state.usersOnline).forEach(userUid => {
                let user = state.usersOnline[userUid]

                if(user.status === 'online'){
                    usersOnline[userUid] = state.allUsers[userUid]
                    usersOnline[userUid].status = user.status
                    usersOnline[userUid].timestamp = user.timestamp
                }
            })

            return usersOnline
        },
        getUserProfileById: (state) => (uid) => {
            let userProfile = state.allUsersNew.filter(user => {
                return user.uid === uid
            })
            if(userProfile.length > 0){
                return userProfile[0]
            }else{
                return null
            }
        },
        getChatByUserIds: (state) => (userUid1, userUid2) => {

            let existingChat = null

            Object.keys(state.chats).forEach(key => {
                let chat = state.chats[key]
                if(Object.keys(chat.info.people).length === 2){
                    if(typeof chat.info.people[userUid1] !== 'undefined' && typeof chat.info.people[userUid2] !== 'undefined'){
                        existingChat = chat
                        existingChat.id = key
                    }
                }
            })
            
            return existingChat
        },
        getAllUserFriends: (state) => {
            return state.userProfileFriends
        },
        isUserInMyFriend: (state) => (uid) => {
            let userFriend = state.userProfileFriends.filter(friend => {
                if(friend.id === uid){
                    return friend
                }
            })
            return userFriend
        },
        getUserFriendsCount: (state) => {
            let userFriends = state.userProfileFriends.filter(friend => {
                if(friend.isFriends === true && friend.status === 'friends'){
                    return friend
                }
            })
            return userFriends.length
        }
    }
})


// WEBPACK FOOTER //
// ./src/store.js